// jQuery(document).ready(function($) {
	
// 	/* Main Banner - BEGIN */
// 		var mainBanner = $(".main-banner");

// 		mainBanner.addClass("owl-carousel").owlCarousel({
// 			items: 1,
// 			margin: 0,
// 			dots: true,
// 			loop: true,
// 			autoplay: 10000,
// 			autoHeight: true,
// 			autoplayHoverPause: true
// 		});
// 	/* Main Banner - END */

// });
(function($){
	var mainBanner = $(".main-banner");

	mainBanner.addClass("owl-carousel").owlCarousel({
		items: 1,
		margin: 0,
		dots: true,
		loop: true,
		autoplay: 10000,
		autoplayHoverPause: true
	});
}(jQuery))